/**
 * REACT_APP_ADMINS: comma-separated adminUser _ids (e.g. "id1,id2" or "[id1,id2]").
 * Users whose _id is in this list are "full admins" — full nav, Command Center admin sections.
 * Restart dev server after changing .env — CRA bakes REACT_APP_* at build time.
 */

export function getAdminIds() {
  const raw = (process.env.REACT_APP_ADMINS || '').replace(/^\[|\]$/g, '').trim();
  return raw ? raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean) : [];
}

/**
 * @param {{ _id?: string; id?: string } | null | undefined} adminInfo - user from Redux login.adminInfo
 * @returns {boolean} true if adminInfo's _id/id is in REACT_APP_ADMINS
 */
export function isFullAdmin(adminInfo) {
  const ids = getAdminIds();
  const idRaw = adminInfo?._id ?? adminInfo?.id;
  const id = idRaw != null ? String(idRaw).trim().toLowerCase() : '';
  return ids.length > 0 && !!id && ids.includes(id);
}
